// extracted by mini-css-extract-plugin
module.exports = {"location_tiles":"ShipmentsTrackPageFeature_location_tiles__WauKK","itemContainer":"ShipmentsTrackPageFeature_itemContainer__y4Ylr","item":"ShipmentsTrackPageFeature_item__2C2rf"};